import logo from './assets/logo.svg';

export const brandConfig = {
    id: 'default',
    storagePrefix: 'storizone',
    name: 'Storizone',
    description: 'The ultimate e-commerce platform.',
    company: {
        name: 'Storizone Inc.',
        address: '123 Commerce St, Market City',
    },
    support: {
        email: 'support@storizone.com',
        phone: '+1 (555) 123-4567',
        url: 'https://support.storizone.com',
    },
    links: {
        website: 'https://storizone.com',
        twitter: 'https://twitter.com/storizone',
        github: 'https://github.com/storizone',
    },
    meta: {
        titleTemplate: '%s | Storizone',
        defaultTitle: 'Storizone',
    },
    logo,
};
